module.exports = __webpack_public_path__ + "static/media/SG_Payslip_1.64730ff4.png";